import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { track } from "@/lib/track";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import { Login, Register } from "@/pages/Auth";
import Account from "@/pages/Account";
import Reviews from "@/pages/Reviews";
import Admin from "@/pages/Admin";

const Loading = () => <div className="grid min-h-[70vh] place-items-center font-mono-j text-xs tracking-[0.3em] text-[#a78bce]">LOADING…</div>;

const PageTracker = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    track("page_view");
  }, [pathname]);
  return children;
};

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App bg-[#07030c]">
      <BrowserRouter>
        <PageTracker>
          <AuthProvider>
            <SmoothScroll />
            <Nav />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/item/:id" element={<Product />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/account" element={<Protected><Account /></Protected>} />
                <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
                <Route path="/admin/analytics" element={<Protected admin><Admin initialTab="analytics" /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-right" theme="dark" />
          </AuthProvider>
        </PageTracker>
      </BrowserRouter>
    </div>
  );
}

export default App;
